import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["csrftoken", "obj_id", "isAuthenticated", "isSharingEnabled", "objtype", "jwt", "initialData", "userAutocomplete"];
import React, { useState } from 'react';

// Import FileUploader for re-export
import { FileUploader } from '../file-uploader';

// Global installation of the Bootstrap CSS.
// TODO: Purgecss to remove unwanted CSS from the final output.
// import 'bootstrap/dist/css/bootstrap.min.css';

import './assets/index.css';

// Get necessary react bootstrap imports.
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Spinner from 'react-bootstrap/Spinner';

// Async select for promise fetch request.
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useDebouncedCallback } from "use-debounce";

// Assets for this share component
import SVGUserAdd from "./assets/svguseradd.js";
//import SVGLink from './assets/svglink.jsx';
import SVGGroup from "./assets/svggroup.js";
import SVGLocked from "./assets/svglocked.js";
import SVGUnlocked from "./assets/svgunlocked.js";
import SVGLogout from "./assets/svglogout.js";
import { Denied } from "./utils/Denied.js";
import { editorCheckLabel } from "./utils/editorCheckLabel.js";
import ExistingInvite from "./utils/existing-invite.js";
import GetLink from "./utils/get-link.js";
import { convertActionToCasper } from './utils/helper.js';
import { ErrorAlert } from "./utils/ErrorAlert.js";
import { ShareForButtonsAbstract } from "./ShareForButtonsAbstract.js";
import { withResponseErrorHandling } from './utils/withResponseErrorHandling.js';
import { isUUID4 } from './utils/uuid';
import SVGBuilding from "./assets/svgbuilding.js";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var useCheckbox = function useCheckbox(initialState) {
  var _React$useState = React.useState(initialState),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isCheckboxChecked = _React$useState2[0],
    setIsCheckboxChecked = _React$useState2[1];
  var checkboxChecked = React.useCallback(function () {
    return setIsCheckboxChecked(function (state) {
      return !state;
    });
  }, [setIsCheckboxChecked]);
  return [isCheckboxChecked, checkboxChecked];
};
function ShareModal(_ref) {
  var csrftoken = _ref.csrftoken,
    obj_id = _ref.obj_id,
    isAuthenticated = _ref.isAuthenticated,
    _ref$isSharingEnabled = _ref.isSharingEnabled,
    isSharingEnabled = _ref$isSharingEnabled === void 0 ? true : _ref$isSharingEnabled,
    _ref$objtype = _ref.objtype,
    objtype = _ref$objtype === void 0 ? "dataset" : _ref$objtype,
    jwt = _ref.jwt,
    initialData = _ref.initialData,
    userAutocomplete = _ref.userAutocomplete,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(isAuthenticated),
    _useState2 = _slicedToArray(_useState, 2),
    isUserAuthenticated = _useState2[0],
    setIsUserAuthenticated = _useState2[1];

  //UI state
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    emails = _useState4[0],
    setEmails = _useState4[1];
  var _useState5 = useState("Viewer"),
    _useState6 = _slicedToArray(_useState5, 2),
    role = _useState6[0],
    setRole = _useState6[1]; // for invitations
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    message = _useState8[0],
    setMessage = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    autocompleteHappened = _useState10[0],
    setAutocompleteHappened = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    numLoading = _useState12[0],
    setNumLoading = _useState12[1];
  var _useCheckbox = useCheckbox(true),
    _useCheckbox2 = _slicedToArray(_useCheckbox, 2),
    notify = _useCheckbox2[0],
    setNotify = _useCheckbox2[1];
  var _useState13 = useState('error' in props ? props.error : undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    error = _useState14[0],
    setError = _useState14[1]; // {title, message}
  var _useCheckbox3 = useCheckbox(true),
    _useCheckbox4 = _slicedToArray(_useCheckbox3, 2),
    invite = _useCheckbox4[0],
    setInvite = _useCheckbox4[1];

  //obj load
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    username = _useState16[0],
    setUsername = _useState16[1];
  var _useState17 = useState(),
    _useState18 = _slicedToArray(_useState17, 2),
    objOwnerPK = _useState18[0],
    setObjOwnerPK = _useState18[1]; //eslint-disable-line no-unused-vars
  var _useState19 = useState(),
    _useState20 = _slicedToArray(_useState19, 2),
    objOwnerName = _useState20[0],
    setObjOwnerName = _useState20[1];
  var _useState21 = useState(),
    _useState22 = _slicedToArray(_useState21, 2),
    objOwnerEmail = _useState22[0],
    setObjOwnerEmail = _useState22[1];
  var _useState23 = useState(),
    _useState24 = _slicedToArray(_useState23, 2),
    objOrganization = _useState24[0],
    setObjOrganization = _useState24[1];
  var _useState25 = useState(),
    _useState26 = _slicedToArray(_useState25, 2),
    objMode = _useState26[0],
    setObjMode = _useState26[1]; // //FIXME missing from backend on first load
  var _useState27 = useState(objtype),
    _useState28 = _slicedToArray(_useState27, 2),
    objType = _useState28[0],
    setObjType = _useState28[1];
  var _useState29 = useState(),
    _useState30 = _slicedToArray(_useState29, 2),
    objPK = _useState30[0],
    setObjPK = _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    existingInvite = _useState32[0],
    setExistingInvite = _useState32[1];
  var _useState33 = useState(),
    _useState34 = _slicedToArray(_useState33, 2),
    selfCanRead = _useState34[0],
    setSelfCanRead = _useState34[1];
  var _useState35 = useState(),
    _useState36 = _slicedToArray(_useState35, 2),
    selfCanWrite = _useState36[0],
    setSelfCanWrite = _useState36[1];
  var _useState37 = useState(),
    _useState38 = _slicedToArray(_useState37, 2),
    selfIsOwner = _useState38[0],
    setSelfIsOwner = _useState38[1];
  var _useState39 = useState(),
    _useState40 = _slicedToArray(_useState39, 2),
    selfIsAdmin = _useState40[0],
    setSelfIsAdmin = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    logoutAlert = _useState42[0],
    setLogoutAlert = _useState42[1];
  var _useState43 = useState(),
    _useState44 = _slicedToArray(_useState43, 2),
    targetUrl = _useState44[0],
    setTargetUrl = _useState44[1];

  //WARNING: Only appears after share link explicitly created
  var _useState45 = useState(),
    _useState46 = _slicedToArray(_useState45, 2),
    linkUUID = _useState46[0],
    setLinkUUID = _useState46[1];
  var _useState47 = useState(),
    _useState48 = _slicedToArray(_useState47, 2),
    orgAction = _useState48[0],
    setorgAction = _useState48[1];
  var modalOnEntered = function modalOnEntered() {
    // Remove if the modal is opened already and have existing invite already populated.
    if (existingInvite.length) {
      setExistingInvite([]);
    }
    var data = initialData instanceof Promise ? initialData : initialData ? new Promise(function (resolve) {
      return resolve(initialData);
    }) : fetchInitialData();
    withResponseErrorHandling(data, 'loading resource sharing information', setNumLoading, setError, setAllEmpty).then(handleInitialDataLoad).catch(function (e) {
      console.error(e);
    });
  };
  var fetchInitialData = function fetchInitialData() {
    if (isUUID4(objPK || obj_id)) {
      return fetch("/api/v2/get/share/link/?obj_type=".concat(objType, "&obj_pk=").concat(obj_id), {
        mode: "cors",
        credentials: "include",
        headers: _objectSpread(_objectSpread({}, isUserAuthenticated ? {
          'X-CSRFToken': csrftoken
        } : {}), {}, {
          'Content-Type': 'application/json'
        })
      }).then(function (res) {
        return res.json();
      });
    } else {
      return new Promise(function (resolve, reject) {
        resolve({
          status: 'DENIED',
          title: 'Share: Denied',
          message: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("p", {
              children: ["Item does not exist, you do not have permission to view, or ", "".concat(objType), " does not support sharing (demo or pre-2.0 API):"]
            }), /*#__PURE__*/_jsxs("ul", {
              children: [/*#__PURE__*/_jsx("li", {
                children: "Confirm the URL with the owner and ask them to give you Viewer or Editor access"
              }), /*#__PURE__*/_jsxs("li", {
                children: ["If an older ", objType, ", reupload with 2.0 APIs or the file uploader"]
              }), /*#__PURE__*/_jsx("li", {
                children: "If the problem persists, please contact staff for assistance"
              })]
            })]
          })
        });
      });
    }
  };
  var refreshData = function refreshData() {
    var data = fetchInitialData();
    return withResponseErrorHandling(data, 'Refreshing resource sharing information', setNumLoading, setError).then(handleInitialDataLoad).catch(function (e) {
      console.error(e);
    });
  };
  var handleInitialDataLoad = function handleInitialDataLoad(response) {
    // Process the response based on the error state.
    if (response && (response.status === "OK" || response.status === 200 || response.status === true) && Object.keys(response.data).length !== 0 && response.data.permission) {
      setUsername(response.data.username);
      setObjOwnerPK(response.data.obj_owner_pk);
      setObjOwnerName(response.data.obj_owner_name);
      setObjOwnerEmail(response.data.obj_owner_email);
      setObjPK(response.data.obj_pk);
      setObjType(response.data.obj_type);
      setObjMode(response.data.mode);
      setObjOrganization(response.data.base_organization);
      setLinkUUID(response.data.uuid); // Watch out: Only defined after initial invite/setting..
      setorgAction(response.data.orgAction); // Only exists when the mode is Organization

      setSelfCanRead(response.data.permission.is_can_read);
      setSelfCanWrite(response.data.permission.is_can_write);
      setSelfIsAdmin(response.data.permission.is_admin || response.data.permission.is_staff);
      setSelfIsOwner(response.data.permission.is_owner);
      setError(undefined);
      if ('invited_users' in response.data) {
        setExistingInvite(response.data.invited_users);
      } else {
        setExistingInvite([]);
      }
      var target_url = null;
      switch (objType) {
        case 'dataset':
          target_url = '/graph/graph.html?dataset=';
          break;
        case 'investigation':
          target_url = '/pivot/investigation/';
          break;
        case 'namedendpoint':
          var d = response.data;
          target_url = '/api/v2/o/' + d.base_organization['slug'] + "/run/" + d.share_obj['type'] + "/";
          break;
        default:
          target_url = '/';
          break;
      }
      setTargetUrl(target_url);
    } else {
      if (response && response.status === 'DENIED') {
        setError({
          title: "Permission denied",
          instructions: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("p", {
              children: "Item does not exist or you do not have permission to access it"
            }), /*#__PURE__*/_jsx("ul", {
              children: /*#__PURE__*/_jsx("li", {
                children: "Confirm the URL with the owner and ask them to give you Viewer or Editor access"
              })
            }), "If the problem persists, contact staff for assistance"]
          }),
          trace: response
        });
      } else {
        setError({
          title: "Error fetching item information",
          instructions: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("p", {
              children: ["Item does not exist, you do not have permission to access it, or its permission controls are disabled (demo ", objType, ", pre-2.0 API):"]
            }), /*#__PURE__*/_jsxs("ul", {
              children: [/*#__PURE__*/_jsx("li", {
                children: "Confirm the URL with the owner and ask them to give you Viewer or Editor access"
              }), /*#__PURE__*/_jsxs("li", {
                children: ["If a demo ", objType, " or pre-2.0 API ", objType, ", reupload it using the API or file uploader"]
              })]
            }), "If the problem persists, contact staff for assistance"]
          }),
          trace: response
        });
      }
    }
  };
  var setAllEmpty = function setAllEmpty() {
    setObjOwnerPK();
    setObjOwnerName();
    setObjOwnerEmail();
    setObjPK();
    setObjMode();
    setObjOrganization();
    setLinkUUID();
    setorgAction();
    setSelfCanRead();
    setSelfCanWrite();
    setSelfIsAdmin();
    setSelfIsOwner();
  };
  var setSelectValue = function setSelectValue(value) {
    // Update the selected value in setEmails and also update the boolean.
    setEmails(value ? value : []);
    setAutocompleteHappened(true);
  };
  var captureOnMenuClose = function captureOnMenuClose() {
    if (!emails.length) {
      setAutocompleteHappened(false);
    }
  };

  // Debounce react-select using the use-debounce pacakge
  var mapOptionsToValues = function mapOptionsToValues(result) {
    return result.data.map(function (option) {
      var label = !option.email || !option.text ? option.text || option.email : option.email === option.text ? option.email : /*#__PURE__*/_jsxs("span", {
        children: [option.text, " ", /*#__PURE__*/_jsxs("i", {
          children: ["(", option.email, ")"]
        })]
      });
      return {
        value: option.email,
        label: label,
        user_name: option.text
      };
    });
  };
  var promiseOptions = function promiseOptions(searchQuery, callback) {
    /*
    {
        "status": "OK",
        "message": "Autocomplete Share User",
        "data": [
            {
                "email": "testadmin@graphistry.com",
                "text": "adminname"
            }
        ]
    }
    */
    ((userAutocomplete ? userAutocomplete(searchQuery) : null) || fetch("/api/v2/search/share/users/?obj_type=" + objType + "&keyword=" + searchQuery, {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: _objectSpread(_objectSpread({}, isUserAuthenticated ? {
        'X-CSRFToken': csrftoken
      } : {}), {}, {
        'Content-Type': 'application/json'
        //'Authorization': 'Bearer ' + jwt
      })
      //headers: isAuthenticated ? {'X-CSRFToken': csrftoken} : {}
    })).then(function (res) {
      return res.json();
    }).then(function (res) {
      if (!res || res.status !== 'OK' || !res.data) {
        console.error('Unexpected autocomplete response', res);
        throw new Error('Unexpected autocomplete response');
      }
      return res;
    }).then(function (response) {
      return callback(mapOptionsToValues(response));
    });
  };
  var loadOptions = useDebouncedCallback(promiseOptions, 350);
  var clickMode = function clickMode() {
    document.querySelectorAll('#dropdown-basic-button')[1].click();
  };
  var handleLogout = function handleLogout(event) {
    event.preventDefault();
    withResponseErrorHandling(fetch("/accounts/logout/", {
      headers: _objectSpread(_objectSpread({}, isUserAuthenticated ? {
        'X-CSRFToken': csrftoken
      } : {}), {}, {
        'Content-Type': 'application/json'
      }),
      method: "POST"
    }).then(function (res) {
      return res.json();
    }), 'User Logout', setNumLoading, setError, setAllEmpty).then(function (response) {
      if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
        setLogoutAlert(false);
        setIsUserAuthenticated(false);
      }
    }).catch(function (e) {
      console.log("E is ", e);
    });
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var convertedAction = convertActionToCasper(role);
    var changedReactSelectEmails = [];
    emails.forEach(function (emailDict) {
      changedReactSelectEmails.push({
        email: emailDict.value,
        user_name: emailDict.user_name,
        action: convertedAction
      });
    });
    withResponseErrorHandling(fetch("/api/v2/create/share/link/", {
      method: "POST",
      mode: 'cors',
      headers: _objectSpread(_objectSpread({}, isUserAuthenticated ? {
        'X-CSRFToken': csrftoken
      } : {}), {}, {
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        obj_pk: obj_id,
        obj_type: objType,
        invited_users: changedReactSelectEmails,
        notify: notify,
        invite: invite,
        message: message,
        mode: objMode
      })
    }).then(function (res) {
      return res.json();
    }), 'inviting users', setNumLoading, setError).then(function (response) {
      if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
        setEmails([]);
        setAutocompleteHappened(false);
        refreshData();
      }
    }).catch(function () {});
  };
  var changeGroup = function changeGroup(group /* 'Public' | 'Private' */) {
    setObjMode(group);
    withResponseErrorHandling(
    // Call update API for changing group value
    fetch("/api/v2/update/share/link/mode/", {
      headers: _objectSpread(_objectSpread({}, isAuthenticated ? {
        "X-CSRFToken": csrftoken
      } : {}), {}, {
        "Content-Type": "application/json"
      }),
      method: "PUT",
      body: JSON.stringify({
        obj_pk: objPK,
        obj_type: objType,
        mode: group.toLowerCase()
      })
    }).then(function (res) {
      return res.json();
    }), "change mode for this share link", setNumLoading, function () {}).then(function (response) {
      if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
        refreshData();
      } else {
        // If no sharelink yet, create an updated one
        withResponseErrorHandling(fetch("/api/v2/create/share/link/", {
          method: "POST",
          headers: _objectSpread(_objectSpread({}, isAuthenticated ? {
            "X-CSRFToken": csrftoken
          } : {}), {}, {
            "Content-Type": "application/json"
          }),
          body: JSON.stringify({
            obj_pk: objPK,
            obj_type: objType,
            mode: group.toLowerCase(),
            invited_users: [],
            notify: false,
            message: "",
            mode_action: "view"
          })
        }).then(function (res) {
          return res.json();
        }), "change mode for the first time for this share link", setNumLoading, setError).then(function (response) {
          if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
            refreshData();
          }
        });
      }
    });
  };
  var deleteShareLink = function deleteShareLink(uuid) {
    withResponseErrorHandling(
    // Call delete API for delete share link
    fetch("/api/v2/update/share/link/mode/", {
      headers: _objectSpread(_objectSpread({}, isAuthenticated ? {
        "X-CSRFToken": csrftoken
      } : {}), {}, {
        "Content-Type": "application/json"
      }),
      method: "DELETE",
      body: JSON.stringify({
        sharelink_id: uuid
      })
    }).then(function (res) {
      return res.json();
    }), "delete this share link", setNumLoading, function () {}).then(function (response) {
      if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
        refreshData();
      }
    });
  };
  var controlShareUnshare = function controlShareUnshare(hasShare) {
    if (hasShare) {
      var text = "Are you certain you want to disable all sharing features? This action will revoke all permissions.";
      if (window.confirm(text) === true) {
        deleteShareLink(linkUUID);
      }
    }
  };
  var cannotRead = function cannotRead() {
    var description = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: "Item does not exist or you do not have permission to access it"
      }), /*#__PURE__*/_jsx("ul", {
        children: /*#__PURE__*/_jsx("li", {
          children: "Confirm the URL with the owner and ask them to give you Viewer or Editor access"
        })
      }), "If the problem persists, contact staff for assistance"]
    });
    return /*#__PURE__*/_jsx(Denied, _objectSpread(_objectSpread({}, props), {}, {
      title: "Access Denied",
      description: description
    }));
  };
  var objPKNotUUID = function objPKNotUUID() {
    var description = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("p", {
        children: ["Item does not exist, you do not have permission to access it, or its permission controls are disabled (demo ", objType, ", pre-2.0 API):"]
      }), /*#__PURE__*/_jsxs("ul", {
        children: [/*#__PURE__*/_jsx("li", {
          children: "Confirm the URL with the owner and ask them to give you Viewer or Editor access"
        }), /*#__PURE__*/_jsxs("li", {
          children: ["If a demo ", objType, " or pre-2.0 API ", objType, ", reupload it using the API or file uploader"]
        })]
      }), "If the problem persists, contact staff for assistance"]
    });
    return /*#__PURE__*/_jsx(Denied, _objectSpread(_objectSpread({}, props), {}, {
      title: 'Access denied',
      description: description
    }));
  };
  return /*#__PURE__*/_jsx(Modal, _objectSpread(_objectSpread({}, props), {}, {
    className: 'share-component',
    size: "lg",
    centered: true,
    onEntered: modalOnEntered,
    contentClassName: "custom-content",
    children: selfCanRead === false ? cannotRead() : objPK && !isUUID4(objPK) ? objPKNotUUID() : /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "first-level",
        children: /*#__PURE__*/_jsxs("div", {
          className: "first-level-content",
          children: [/*#__PURE__*/_jsxs(Modal.Header, {
            children: [/*#__PURE__*/_jsxs(Modal.Title, {
              id: "contained-modal-title-vcenter",
              children: [/*#__PURE__*/_jsx("div", {
                className: "header-image",
                children: /*#__PURE__*/_jsx(SVGUserAdd, {
                  className: "header-svg"
                })
              }), "Share with individuals"]
            }), /*#__PURE__*/_jsx("div", {
              className: "modal-title h4",
              children: !objMode ? /*#__PURE__*/_jsx(Spinner, {
                animation: "border",
                variant: "secondary",
                size: "sm"
              }) : /*#__PURE__*/_jsxs(_Fragment, {
                children: [isUserAuthenticated ? /*#__PURE__*/_jsxs(_Fragment, {
                  children: [username, /*#__PURE__*/_jsx("div", {
                    id: "btn-logout",
                    title: "Logout",
                    className: "header-image header-mode float-right first-image c-pointer",
                    children: /*#__PURE__*/_jsx("span", {
                      onClick: function onClick() {
                        return setLogoutAlert(true);
                      },
                      children: /*#__PURE__*/_jsx(SVGLogout, {
                        classname: "header-svg"
                      })
                    })
                  })]
                }) : null, /*#__PURE__*/_jsx("div", {
                  id: "share-mode-icon-cont",
                  title: objMode,
                  className: "header-image header-mode float-right c-pointer",
                  onClick: clickMode,
                  children: objMode === 'public' ? /*#__PURE__*/_jsx("span", {
                    children: /*#__PURE__*/_jsx(SVGUnlocked, {
                      className: "header-svg"
                    })
                  }) : objMode === 'private' ? /*#__PURE__*/_jsx(SVGLocked, {
                    className: "header-svg"
                  }) : objMode === 'organization' ? /*#__PURE__*/_jsx(SVGBuilding, {
                    className: "header-svg"
                  }) : null
                })]
              })
            })]
          }), /*#__PURE__*/_jsxs(Modal.Body, {
            children: [logoutAlert && /*#__PURE__*/_jsx(ErrorAlert, {
              variant: "light",
              _style: {
                color: "#960014",
                borderColor: "#ff4961",
                backgroundColor: "#ffdbe0"
              },
              _hr_style: {
                borderTopColor: "#ffb3bd"
              },
              dismiss_variant: "danger",
              message: "double confirm for logout",
              instructions: /*#__PURE__*/_jsxs("p", {
                children: ["Are you sure you want to Logout?", /*#__PURE__*/_jsx("span", {
                  style: {
                    margin: '1em'
                  },
                  onClick: handleLogout,
                  children: /*#__PURE__*/_jsx(Button, {
                    variant: "danger",
                    children: "Yes, Logout"
                  })
                })]
              }),
              onDismiss: function onDismiss() {
                return setLogoutAlert(false);
              }
            }), !isUserAuthenticated ? /*#__PURE__*/_jsx(ErrorAlert, {
              variant: "primary",
              instructions: /*#__PURE__*/_jsxs("p", {
                children: ["To edit sharing settings, first", /*#__PURE__*/_jsx("a", {
                  style: {
                    margin: '0.5em'
                  },
                  href: "/accounts/login/?next=".concat(targetUrl).concat(obj_id),
                  children: /*#__PURE__*/_jsx(Button, {
                    children: "sign in"
                  })
                }), "or", /*#__PURE__*/_jsx("a", {
                  style: {
                    margin: '0.5em'
                  },
                  href: "/accounts/signup/?next=".concat(targetUrl).concat(obj_id),
                  children: /*#__PURE__*/_jsx(Button, {
                    children: "create an account"
                  })
                })]
              }),
              onDismiss: function onDismiss() {
                return setError(undefined);
              }
            }) : !isSharingEnabled ? /*#__PURE__*/_jsx(ErrorAlert, {
              variant: "primary",
              instructions: 'Contact staff for access to sharing controls and other Hub Pro features',
              onDismiss: function onDismiss() {
                return setError(undefined);
              }
            }) : null, error ? /*#__PURE__*/_jsx(ErrorAlert, _objectSpread(_objectSpread({}, error), {}, {
              onDismiss: function onDismiss() {
                return setError(undefined);
              }
            })) : null, selfCanRead === true && selfCanWrite === false ? /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx("i", {
                children: "Ask owner for Editor access for further control"
              })
            }) : null, /*#__PURE__*/_jsx(Form, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  xs: 10,
                  sm: 10,
                  md: 10,
                  lg: 10,
                  xl: 10,
                  children: /*#__PURE__*/_jsx(Form.Group, {
                    children: /*#__PURE__*/_jsx(AsyncCreatableSelect, {
                      isDisabled: !isSharingEnabled,
                      loadOptions: loadOptions,
                      cacheOptions: true,
                      isMulti: true,
                      onChange: function onChange(value) {
                        return setSelectValue(value);
                      },
                      onMenuClose: captureOnMenuClose,
                      value: emails
                    })
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  className: "share-role-col",
                  children: /*#__PURE__*/_jsx(Form.Group, {
                    children: /*#__PURE__*/_jsxs(DropdownButton, {
                      id: "dropdown-basic-button",
                      title: role.charAt(0).toUpperCase() + role.substring(1),
                      variant: "primary btn-block",
                      "aria-expanded": "true",
                      disabled: !isSharingEnabled,
                      children: [/*#__PURE__*/_jsx(Dropdown.Item, {
                        onClick: function onClick() {
                          return setRole("Viewer");
                        },
                        children: "Viewer"
                      }), /*#__PURE__*/_jsxs(Dropdown.Item, {
                        disabled: !selfCanWrite,
                        onClick: function onClick() {
                          return setRole("Editor");
                        },
                        children: ["Editor ", editorCheckLabel(selfCanWrite === false)]
                      })]
                    })
                  })
                })]
              })
            }), /*#__PURE__*/_jsx(Form.Group, {
              className: "share-checkbox-group",
              children: /*#__PURE__*/_jsxs("div", {
                className: "share-checkbox-row",
                children: [/*#__PURE__*/_jsx(Form.Check, {
                  id: "share-notify-individuals",
                  type: "checkbox",
                  inline: true,
                  checked: notify,
                  label: "Notify individuals",
                  onChange: setNotify,
                  disabled: !isSharingEnabled,
                  className: "share-checkbox"
                }), /*#__PURE__*/_jsx(Form.Check, {
                  id: "share-invite-organization",
                  type: "checkbox",
                  inline: true,
                  checked: invite,
                  label: "Invite to organization",
                  onChange: setInvite,
                  disabled: objMode !== 'organization',
                  className: "share-checkbox share-checkbox-secondary"
                })]
              })
            }), /*#__PURE__*/_jsxs(Form.Group, {
              controlId: "exampleForm.ControlTextarea1",
              className: "mb-1",
              style: {
                display: (autocompleteHappened || emails.length) && notify ? 'block' : 'none'
              },
              children: [/*#__PURE__*/_jsx(Form.Label, {
                children: "Message"
              }), /*#__PURE__*/_jsx(Form.Control, {
                as: "textarea",
                rows: 3,
                onChange: function onChange(event) {
                  return setMessage(event.target.value);
                }
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(ExistingInvite, {
                isAuthenticated: isUserAuthenticated,
                selfCanWrite: selfCanWrite,
                selfIsAdmin: selfIsAdmin,
                selfIsOwner: selfIsOwner,
                objOwnerName: objOwnerName,
                objOwnerEmail: objOwnerEmail,
                objPK: objPK,
                objMode: objMode,
                objType: objType,
                linkUUID: linkUUID,
                existingInvite: existingInvite,
                setExistingInvite: setExistingInvite,
                setNumLoading: setNumLoading,
                setError: setError,
                shareOnHide: props.onHide,
                refreshData: refreshData,
                csrftoken: csrftoken,
                isSharingEnabled: isSharingEnabled,
                username: username
              })
            })]
          }), /*#__PURE__*/_jsx(Modal.Footer, {
            children: emails.length || autocompleteHappened ? /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(Button, {
                variant: "light",
                className: "share-footer-cancel",
                onClick: props.onHide,
                children: "Cancel"
              }), objMode === 'organization' ? /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx(Button, {
                  onClick: function onClick(e) {
                    handleSubmit(e);
                  },
                  children: "Invite"
                })
              }) : /*#__PURE__*/_jsx(Button, {
                onClick: handleSubmit,
                children: "Invite"
              })]
            }) : /*#__PURE__*/_jsx(Button, {
              onClick: props.onHide,
              variant: "primary",
              children: "Done"
            })
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "second-level",
        children: /*#__PURE__*/_jsxs("div", {
          className: "second-level-content",
          children: [/*#__PURE__*/_jsx(Modal.Header, {
            children: /*#__PURE__*/_jsxs(Modal.Title, {
              id: "contained-modal-title-vcenter",
              children: [/*#__PURE__*/_jsx("div", {
                className: "header-image",
                children: /*#__PURE__*/_jsx(SVGGroup, {
                  className: "header-svg"
                })
              }), "Group settings"]
            })
          }), /*#__PURE__*/_jsx(Modal.Body, {
            children: objPK && /*#__PURE__*/_jsx(GetLink, {
              objPK: objPK,
              objType: objType,
              objMode: objMode,
              setObjMode: setObjMode,
              setNumLoading: setNumLoading,
              setError: setError,
              csrftoken: csrftoken,
              isAuthenticated: isUserAuthenticated,
              selfIsAdmin: selfIsAdmin,
              selfCanWrite: selfCanWrite,
              isSharingEnabled: isSharingEnabled,
              refreshData: refreshData,
              orgAction: orgAction,
              objOrganization: objOrganization,
              target_url: targetUrl,
              changeGroup: changeGroup,
              linkUUID: linkUUID
            })
          }), /*#__PURE__*/_jsxs(Modal.Footer, {
            children: [(selfIsOwner || selfIsAdmin) && objType === 'investigation' && !!linkUUID && /*#__PURE__*/_jsx("div", {
              style: {
                position: 'absolute',
                left: '20px'
              },
              children: /*#__PURE__*/_jsx(Button, {
                className: "share-danger-icon-btn",
                variant: "danger",
                onClick: function onClick() {
                  return controlShareUnshare(!!linkUUID);
                },
                children: /*#__PURE__*/_jsx("i", {
                  className: "fa fa-fw fa-trash"
                })
              })
            }), /*#__PURE__*/_jsx(Button, {
              onClick: props.onHide,
              variant: "primary",
              children: "Done"
            })]
          })]
        })
      })]
    })
  }));
}
ShareModal.defaultProps = {
  onHide: function onHide() {}
};
function ShareForButtons(props) {
  return /*#__PURE__*/_jsx(ShareForButtonsAbstract, _objectSpread({
    Share: ShareModal
  }, props));
}
var fetchGetPermission = function fetchGetPermission(isUserAuthenticated, csrftoken, objType, obj_id) {
  if (isUUID4(obj_id)) {
    var url = "/api/v2/get/my/object/permission/";
    var requestBody = JSON.stringify({
      obj_type: objType,
      obj_pk: obj_id
    });
    return fetch(url, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: _objectSpread(_objectSpread({}, isUserAuthenticated ? {
        "X-CSRFToken": csrftoken
      } : {}), {}, {
        "Content-Type": "application/json"
      }),
      body: requestBody
    }).then(function (res) {
      return res.json();
    });
  } else {
    return new Promise(function (resolve, reject) {
      resolve({
        status: "DENIED",
        message: "Share: Denied",
        data: {}
      });
    });
  }
};

// Default export as object to expose all components via UMD's Share global
export default {
  ShareModal: ShareModal,
  ShareForButtons: ShareForButtons,
  fetchGetPermission: fetchGetPermission,
  FileUploader: FileUploader
};

// Named exports for ES module imports
export { ShareModal, ShareForButtons, fetchGetPermission, FileUploader };